import {
  EDialogType,
  EViewerMode,
  ProjectDetailContext,
} from "../Interfaces/ProjectDetailInterfaces";
import { Q3DButton } from "../../Parts/Q3DButton";
import { Q3DTabPanel } from "../../Parts/Q3DTabPanel";

import CloudUpload from "../../../../images/icons/Cloud Upload.svg";
import { useTranslation } from "react-i18next";
import { useContext } from "react";
import { useTheme } from "@mui/material";

type Props = {
  width?: string;
};

export const ExpoTabPanel = (props: Props) => {
  const { updateCurrentDialog } = useContext(ProjectDetailContext);
  const theme = useTheme();

  return (
    <Q3DTabPanel
      value={EViewerMode.EXPORT_TO_OTHER}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: "var(--space-space--4, 4px)",
        width: props.width,
        paddingLeft: "4px",
      }}
    >
      <Q3DButton
        text={"Smart Construction Dashboard"}
        icon={<img src={CloudUpload} alt="" style={{ filter: "invert()" }} />}
        height={"36px"}
        onClick={() => {
          updateCurrentDialog(EDialogType.REGISTER_WITH_DASHBOARD);
        }}
        sx={{
          background: theme.palette.base.ymdBackground,
        }}
      />
      <Q3DButton
        text={"Landlog Viewer"}
        icon={<img src={CloudUpload} alt="" style={{ filter: "invert()" }} />}
        height={"36px"}
        onClick={() => {
          updateCurrentDialog(EDialogType.REGISTER_WITH_LLV);
        }}
        sx={{
          background: theme.palette.base.ymdBackground,
        }}
      />
    </Q3DTabPanel>
  );
};
